import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AppThemeProvider } from './theme/AppThemeProvider';
import { BrandingProvider } from './context/BrandingContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <BrandingProvider>
        <App />
      </BrandingProvider>
    </AppThemeProvider>
  </React.StrictMode>
);
